import { AppSettingType } from "@api/apiClient";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import _ from "lodash";
import { initReactI18next } from "react-i18next";

// TODO: type me
export const supportedLanguages = [
  { locale: "en", locales: ["en", "en-US"], label: "English", mui: "enUS" },
  { locale: "de", locales: ["de", "de-DE"], label: "German", mui: "deDE" },
  { locale: "ja", locales: ["ja", "ja-JP"], label: "日本語", mui: "jaJP" },
];

// use browser language
//const language = navigator.language;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    //lng: supportedLanguages.find((lang) => lang.locales.includes(language))?.locale || 'en', // <--- turn off for detection to work
    fallbackLng: (code: string) => {
      if (code === "ja" || code === "ja-JP") {
        return "ja";
      }
      if (code === "de" || code === "de-DE") {
        return "de";
      }
      return "en";
    },
    supportedLngs: supportedLanguages.map((lang) => lang.locale),
    interpolation: {
      skipOnVariables: false,
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
      requestOptions: {
        cache: 'no-store',
      },
    },
    options: {
      appSettings: new Map<AppSettingType, any>(),
    }
  } as any);

class NumberFormatter {
  format(value: number | null | undefined, lng: string | undefined, options: any): string {
    // appSettings are retrieved from the server dbo.AppSettings table and assigned in App.tsx
    const digits = i18n.options.appSettings.get(options.digits);

    if (digits === undefined) {
      return Intl.NumberFormat(lng, { ...options, minimumFractionDigits: options.minimumFractionDigits, maximumFractionDigits: options.maximumFractionDigits }).format(value || 0);
    } else {
      const numS = value?.toString() || '0';
      const decPos = numS.indexOf('.');
      const substrLength = decPos === -1 ? numS.length : 1 + decPos + digits;
      const trimmedResult = numS.substr(0, substrLength);
      const sanitizedResult = isNaN(+trimmedResult) ? '0' : trimmedResult;
      const finalResult = parseFloat(sanitizedResult);

      return Intl.NumberFormat(lng, { ...options, minimumFractionDigits: options.minimumFractionDigits ?? digits, maximumFractionDigits: options.maximumFractionDigits ?? digits }).format(finalResult);
    }
  }
}

const numberFormatter = new NumberFormatter();

i18n.services.formatter?.add("number", (val, lng, options) => {
  if (!options?.style || options?.style === "number") {
    return numberFormatter.format(val, lng, options);
  }

  if (!val) {
    return "";
  }

  const value = typeof val === 'string' ? parseFloat(val) : val;
  const decimalVal = value.toFixed(1);

  if (options?.style === "percent") {
    if (_.isFinite(value)) {
      return Intl.NumberFormat(lng, { ...options, style: 'unit', unit: 'percent' }).format(decimalVal);
    } else {
      return "";
    }
  } else if (options?.style === "percent-or-empty") {
    if (_.isFinite(value) && value > 0) {
      return Intl.NumberFormat(lng, { ...options, style: 'unit', unit: 'percent' }).format(decimalVal);
    } else {
      return "";
    }
  } else {
    return Intl.NumberFormat(lng, options).format(decimalVal);
  }
});

i18n.services.formatter?.add("datetime", (val, lng, options) => {
  if (isNaN(val)) {
    return "";
  }
  return Intl.DateTimeFormat(lng, options).format(val);
});

i18n.on("languageChanged", (locale: string) => {
  console.log("Language changed to " + locale);
});

export default i18n;
